import { Box, SxProps } from '@mui/material';
import { Header } from 'common/ui/Header';
import { NoATSUploadCVStep } from 'pages/CandidatesRanking/components/steps/NoATSUploadCVStep';
import { useLocation, useNavigate } from 'react-router-dom';
import { addCVsToCandidateBatch } from 'services/candidate/api';
import { useLoadingOverlay } from 'services/loading/hooks';
import { Paths } from 'services/navigation/paths';
import { ToastType, useToast } from 'services/toast';
import {
  layoutContainerPaddingBottom,
  layoutContainerPaddingTop,
  layoutContainerPaddingX
} from 'services/navigation/components/PrivateRoute';

const container: SxProps = {
  pt: layoutContainerPaddingTop,
  pb: layoutContainerPaddingBottom,
  px: layoutContainerPaddingX
};

const bodyContainer: SxProps = {
  mt: 4
};

const title = 'Upload CV';

export const NoATSAnalysisAddCV = () => {
  const { showLoadingOverlay, hideLoadingOverlay } = useLoadingOverlay();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const location = useLocation();
  const { candidateBatchId } = location.state;

  if (!candidateBatchId) {
    return null;
  }

  return (
    <Box sx={container}>
      <Header
        title={title}
        items={[
          'Upload multiple CVs as PDF, TXT, DOCX, or HTML files, so we can extract the data needed to build a campaign'
        ]}
        breadcrumbs={[{ name: 'Analyse', path: Paths.ANALYSE }]}
        currentBreadcrumb={title}
        onBack={() => navigate(-1)}
      />
      <Box sx={bodyContainer}>
        <NoATSUploadCVStep
          filesWithS3Keys={[]}
          onNext={async (filesWithS3Keys) => {
            showLoadingOverlay();

            const cvS3Keys = filesWithS3Keys.map(
              (fileWithS3Key) => fileWithS3Key.s3Key
            );

            const { id } = await addCVsToCandidateBatch({
              cvS3Keys,
              candidateBatchId
            });

            showToast({
              message: 'CVs added successfully',
              type: ToastType.Success
            });
            hideLoadingOverlay();
            navigate(`${Paths.ANALYSE}/${id}`);
          }}
        />
      </Box>
    </Box>
  );
};
